function requiredError(field, errorText = "is required") {
  return `${field} ${errorText}`;
}

export default requiredError;